import React from "react";

import { isFuture } from "date-fns/isFuture";
import { graphql, useStaticQuery } from "gatsby";

import filterByCategory from "./utils";
import BackgroundImage from "../../components/backgroundImage/backgroundImage";
import MegaMenuResult from "../../components/megaMenuResult/megaMenuResult";
import backgroundImageHelper from "../image/backgroundImageHelper";
import KontentItemImage from "../kontentItemImage";

interface MegaMenuResultsEventProps {
  item?: {
    categories?: string[];
  };
}

interface MegaMenuResultsEventQuery {
  allKontentItemEvent: {
    nodes: Queries.kontent_item_event[];
  };
}

const MegaMenuResultsEvent: React.FC<MegaMenuResultsEventProps> = ({ item = null }) => {
  const data: MegaMenuResultsEventQuery = useStaticQuery(graphql`
    {
      allKontentItemEvent(
        sort: {elements: {date_start: {value: DESC}}},
        limit: 200
      ) {
        nodes {
          id
          system {
            codename
          }
          elements {
            title {
              value
            }
            image {
              value {
                ...KontentItemImage
                ...KontentItemVideo
              }
            }
            date_end {
              value
            }
            event_category {
              value {
                codename
              }
            }
          }
        }
      }
    }
  `);

  if (!data) {
    return null;
  }

  const filteredByEndDate = data.allKontentItemEvent.nodes.filter(
    (event) => isFuture(new Date(event.elements?.date_end?.value || "")),
  );

  const filteredData = filterByCategory(filteredByEndDate, "event_category", item?.categories || []);

  const slicedData = filteredData.slice(0, 4);

  return (slicedData as Queries.kontent_item_event[]).map((event) => (
    <>
      <MegaMenuResult
        key={event.id}
        href={event.id}
        image={(event.elements?.image?.value?.[0]?.system?.type === "image"
          ? (
            <KontentItemImage
              data={event.elements?.image?.value?.[0] as Queries.kontent_item_image}
              width={48}
              height={48}
              aspectRatio={1}
              fit="crop"
              defaultImage
            />
          )
          : (
            <div className="image-wrapper">
              <BackgroundImage
                className="w-100 h-100"
                backgroundImageStyle={{
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  ...backgroundImageHelper(event.elements?.image?.value?.[0] as Queries.kontent_item_image),
                }}
              />
            </div>
          )
      )}
      >
        {event.elements?.title?.value}
      </MegaMenuResult>
    </>
  ));
};

export default MegaMenuResultsEvent;
